import Immutable from 'immutable';
import {
  PageReadyForReview,
  PageReadyForReviewList,
  RawPageReadyForReview,
} from './PageReadyForReview';

export interface RawPagesReadyForReview {
  uploader: string;
  uploadTimestamp: number;
  processingRequestid: string;
  pages: RawPageReadyForReview[];
  cursor: string;
}

export interface PagesReadyForReviewData {
  uploader: string;
  uploadTimestamp: number;
  processingRequestid: string;
  pages: PageReadyForReviewList;
  cursor: string;
}

const defaultValues: PagesReadyForReviewData = {
  uploader: '',
  uploadTimestamp: 0,
  processingRequestid: '',
  pages: Immutable.List(),
  cursor: '',
};

export const PagesReadyForReviewFactory = Immutable.Record(
  defaultValues,
  'PagesReadyForReview'
);

export class PagesReadyForReview extends PagesReadyForReviewFactory {
  static deserialize(
    rawPagesReadyForReview: RawPagesReadyForReview
  ): PagesReadyForReview {
    return new PagesReadyForReview({
      ...rawPagesReadyForReview,
      pages: Immutable.List(
        rawPagesReadyForReview.pages.map(PageReadyForReview.deserialize)
      ),
    });
  }

  serialize(): RawPagesReadyForReview {
    return this.toJS();
  }
}
